import script from "./StudentCreatePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentCreatePopup.vue?vue&type=script&setup=true&lang=js"

import "./StudentCreatePopup.vue?vue&type=style&index=0&id=54f5bbfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54f5bbfa"]])

export default __exports__